<template>
  <v-autocomplete
    class="small-text-field"
    :required="required"
    :value="preassignedDriver"
    :label="label"
    :items="drivers"
    :v-model="preassignedDriver"
    item-value="id"
    item-name="id"
    item-text="idname"
    @input="updateSelf"
    single-line
    solo
    :height="28"
    flat
    :hide-details="valid() == true && (error == null || error.length == 0)"
    :error-messages="valid() == true ? null : [valid()] "
    :loading="loading"
    @focus="focused"
  >
    <template v-slot:selection="{ item, index }">
      <span style="font-size: 12px !important;" v-html="htmlForDriver(item)"></span>
    </template>
    <template v-slot:item="{ item, index }">
      <span style="font-size: 12px !important;" v-html="htmlForDriver(item)"></span>
    </template>
  </v-autocomplete>
</template>

<script>
import moment from "moment";

import axios from "axios";
import { setTimeout } from "timers";
axios.defaults.withCredentials = true;

export default {
  name: "SelectableDriverDropdownInput",
  model: {
    prop: "preassignedDriver",
    event: "input",
  },
  props: {
    label: String,
    errorMessages: Object,
    required: { type: Boolean, default: true },
    preassignedDriver: Number,
    bookingSummary: Object,
    error: String,
  },
  computed: {},
  data() {
    return {
      menu: false,
      drivers: [],
      loading: false,
    };
  },
  methods: {
    valid() {
      // console.log(this.error);

      if (this.error == null) {
        return true;
      }

      return this.error;
    },
    willBeActive(p) {
      return this.bookingForm.promocodeWillBeActive(p);
    },
    htmlForDriver(item) {
      return (
        "<p><b>" + item.callsign + "&nbsp;-&nbsp;</b>" + item.name + "</p>"
      );
    },

    updateSelf(id) {
      this.preassignBooking(id);
    },
    success(id) {
      var dv = this.drivers.find(function (d) {
        return d.id == id;
      });

      console.log(id + " " + dv.name);
      this.bookingSummary.preassigned_driver_name = dv.name;
      this.bookingSummary.preassigned_driver_callsign = dv.callsign;
      this.bookingSummary.preassigned_driver_id = dv.id;

      this.$emit("input", id);
      this.$emit("name", dv.name);

      var vm = this;

      vm.$nextTick(function () {
        vm.$forceUpdate();
      });
    },
    async focused() {
      console.log("focused");
      this.$emit("focused");

      this.getEligibleDriversForPreassign();
    },
    getEligibleDriversForPreassign() {
      var url = `${this.$store.state.apiUrl}/overwatch/getEligibleDriversForPreassignForBooking?booking_id=${this.bookingSummary.id}`;

      var vm = this;

      axios({
        url: url,
        method: "GET",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {
          if (res.data.error == "no_error") {
            vm.drivers = res.data.drivers;

            for (var i = 0; i < vm.drivers.length; i++) {
              vm.drivers[i].idname =
                vm.drivers[i].callsign + " " + vm.drivers[i].name;
            }
          } else {
            if (res.data.error != null) {
              alert(res.data.error);
            }
          }
        })
        .catch(function (err) {
          console.error(err);
        });
    },
    preassignBooking(driverId) {
      console.log("Preassigning booking to driver " + driverId);

      var url =
        `${this.$store.state.apiUrl}/booking/preassign/${this.bookingSummary.id}?driver_id=` +
        driverId;

      console.log(url);

      var vm = this;

      axios({
        url: url,
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {
          if (res.data.error == "no_error") {
            vm.success(driverId);

            vm.$emit("preassigned", vm.bookingSummary);
          } else {
            if (res.data.error != null) {
              alert(res.data.error);
            }
          }
        })
        .catch(function (err) {
          console.error(err);
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>
